"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayStyles = exports.getContentStyles = exports.WrapperButtons = exports.Title = exports.Subtitle = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
var _colorUtils = require("../../utils/color-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getContentStyles = exports.getContentStyles = function getContentStyles(_ref) {
  var isDesktop = _ref.isDesktop;
  return {
    border: 0,
    borderRadius: 4,
    bottom: 'auto',
    boxShadow: ['0 24px 38px rgba(0, 0, 0, 0.14)', '0 9px 46px rgba(0, 0, 0, 0.12)', '0 11px 15px rgba(0, 0, 0, 0.2)'].join(),
    display: 'flex',
    flexDirection: 'column',
    left: '50%',
    minHeight: isDesktop ? 164 : 172,
    padding: 24,
    position: 'fixed',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: isDesktop ? 560 : 280
  };
};
var getOverlayStyles = exports.getOverlayStyles = function getOverlayStyles() {
  return {
    backgroundColor: (0, _colorUtils.transparentize)(_palette.commonPalette.txGrey, 0.3),
    zIndex: 100000
  };
};
var Title = exports.Title = _styledComponents["default"].div.withConfig({
  displayName: "styles__Title",
  componentId: "sc-nwk4he-0"
})(["font-size:16px;line-height:20px;margin:0 0 19px;"]);
var Subtitle = exports.Subtitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__Subtitle",
  componentId: "sc-nwk4he-1"
})(["color:rgba(0,0,0,0.6);font-size:14px;line-height:20px;margin:0 0 24px;"]);
var Button = exports.Button = _styledComponents["default"].div.withConfig({
  displayName: "styles__Button",
  componentId: "sc-nwk4he-2"
})(["border-radius:4px;cursor:pointer;font-size:14px;font-weight:bold;letter-spacing:1.25px;line-height:40px;margin-left:10px;padding:0 12px;text-transform:uppercase;white-space:nowrap;&:hover{background:rgba(0,0,0,0.05);}"]);
var WrapperButtons = exports.WrapperButtons = _styledComponents["default"].div.withConfig({
  displayName: "styles__WrapperButtons",
  componentId: "sc-nwk4he-3"
})(["display:flex;flex-wrap:wrap;justify-content:flex-end;margin:auto -18px -19px;"]);
//# sourceMappingURL=styles.js.map